import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const geteceactivityskillThunk = createAsyncThunk(
  "eceskillsetmanager/geteceactivityskill",
  async (clas) => {
    // const {  clas } = params;
    let response = await api.get("getAllEceSkills/" + clas);
    return response.data;
  }
);

export const createeceskillmasterThunk = createAsyncThunk(
  "eceskillsetmanager/createeceactivityskill",
  async (body) => {
    let response = await api.post("createNewEceSkills/", body);
    return response.data;
  }
);

export const updateeceskillmasterThunk = createAsyncThunk(
  "eceskillsetmanager/updateeceactivityskill",
  async (reqbody) => {
    const skillid = reqbody.skillid;
    const body = reqbody.body;
    let response = await api.put("updateEceSkills/" + skillid, body);
    return response.data;
  }
);

export const deleteeceskillmasterThunk = createAsyncThunk(
  "eceskillsetmanager/deleteeceactivityskill",
  async (skillid) => {
    let response = await api.delete("deleteEceSkills/" + skillid);
    return response.data;
  }
);
